import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../assets/css/styles.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                usuario: null,
                clave: null
            },
            errors: [],
            loading: false,
            redirectTo: null,
            loginEnabled : ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            loadingLogoLogin: true,
            logoLoginUrl: null,
            languages: [],
            languagesExtra: {
                "es": props.intl.formatMessage({id: 'login.languages.español', defaultMessage: 'Español'}),
                "en": props.intl.formatMessage({id: 'login.languages.ingles', defaultMessage: 'Inglés'})
            },
            // --- VARIABLES REBRANDING ---
            isLegacyDomain: false,
            targetUrl: '',
            countdown: 5
        }

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.changeLocale = this.changeLocale.bind(this);
        this.loginRandom = null;
        this.redirectInterval = null; 
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.usuario': (value) => Validator.notEmpty(value),
                'formData.clave': (value) => Validator.notEmpty(value)
            }
        });

        fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        }).then(response => {
            let contentType = response.headers.get('Content-Type');
            if (contentType && contentType.startsWith('image/')) {
                return response.blob();
            } else {
                throw new Error('No es imagen');
            }
        }).then(blob => {
            let fileUrl = URL.createObjectURL(blob);
            this.setState({ logoLoginUrl: fileUrl });
        }).catch(() => {}).finally(() => {
            this.setState({ loadingLogoLogin: false });
        });
    }

    componentDidMount () {
        // LÓGICA REDIRECCIÓN TELECOM
        const hostname = window.location.hostname;
        const isOldProd = (hostname === 'telecom.vec.com.ar' || hostname === 'telecom.vecfleet.io');
        const isOldTest = (hostname === 'testing-teco.vec.com.ar');

        if (isOldProd || isOldTest) {
            const target = isOldProd ? 'https://personal.vecfleet.io' : 'https://personal-test.vecfleet.io';
            this.setState({ isLegacyDomain: true, targetUrl: target });

            this.redirectInterval = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.redirectInterval);
                        window.location.replace(target);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }

        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        fetch(Config.get('apiUrlBase') + '/public/auth/services', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => { this.setState({ loginServices: data }) });
            }
        }).catch(() => {}).finally(() => {
            this.setState({ loading: false });
            if (this.state.loginServices.classic === 'true' && this.refs.usuario) {
                this.refs.usuario.focus();
            }
        });

        let lang = ConfigBusiness.get("frontend.multilenguaje");
        try {
            const langJson = JSON.parse(lang);
            if (langJson) {
                this.setState({
                    languages: langJson.map(elem => {
                        elem.title = this.state.languagesExtra[elem.lang];
                        return elem;
                    })
                });
            }
        } catch (e) {}
    }

    componentWillUnmount() {
        if (this.redirectInterval) clearInterval(this.redirectInterval);
    }

    handleFormChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let formDataCopy = {...this.state.formData};
        formDataCopy[name] = value;
        this.setState({ formData: formDataCopy });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, errors: [] });
        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({...this.state.formData}),
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    if(data && data.usuario && data.usuario.token) {
                        localStorage.setItem('persona', JSON.stringify(data));
                        localStorage.setItem('token', data.usuario.token);
                        window.location.reload();
                    } else { this.error(); }
                });
            } else if(response.status === 401) {
                response.json().then(data => { this.setState({ errors: data.detalle }); });
            } else { this.error(); }
        }).catch(() => { this.error(); }).finally(() => { this.setState({ loading: false }); });
    }

    handleForgotPassword(e) {
        e.preventDefault();
        this.setState({ redirectTo: '/olvide-clave' });
    }

    changeLocale(locale) {
        localStorage.setItem('userLocale', locale);
        window.location.reload();
    }

    error() {
        swal({ title: "Error", text: "Contacte al administrador.", icon: "error" });
    }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor(3 * Math.random());

        const deadlineDate = new Date('2026-01-08T00:00:00');
        const now = new Date();
        const dateText = now > deadlineDate 
            ? "Esta URL dejará de estar operativa próximamente." 
            : "Esta URL dejará de estar operativa el 08/01/2026.";

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension")==='true' && <Notificacion title="Alerta" message="Pago pendiente" top="0" />}
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                            </video>
                            
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-md-4 col-10 box-shadow-2 p-0">
                                        <div className="card border-grey border-lighten-3 px-2 py-2 m-0">
                                            
                                            <div className="card-header border-0 text-center" style={{padding: 0}}>
                                                <img src={this.state.logoLoginUrl || process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} alt="Logo" className="img-fluid center-block" />
                                            </div>

                                            <div className="card-content">
                                                <div className="card-body" style={{paddingTop: 0}}>
                                                    {this.state.isLegacyDomain ? (
                                                        <div className="text-center py-2">
                                                            <h3 className="mb-2" style={{color: '#0033A0', fontWeight: 'bold'}}>¡Nos estamos mudando!</h3>
                                                            <p className="text-muted">Estamos renovando nuestra imagen para brindarte una mejor experiencia.</p>
                                                            <p className="font-weight-bold text-danger">{dateText}</p>
                                                            <div className="mt-2 mb-3">
                                                                <small>Redirigiendo automáticamente en <strong>{this.state.countdown}</strong>s...</small>
                                                            </div>
                                                            <button className="btn btn-success btn-lg btn-block" onClick={() => window.location.href = this.state.targetUrl}>
                                                                Ir al nuevo sitio . . .
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="login-normal-flow">
                                                            {this.state.loginEnabled === "false" ? (
                                                                <div className="text-center"><h3>Plataforma no disponible.</h3></div>
                                                            ) : (
                                                                <React.Fragment>
                                                                    {this.state.loginServices.classic === 'true' && (
                                                                        <form className="form-horizontal" onSubmit={this.handleSubmit}>
                                                                            <fieldset className="form-group position-relative has-icon-left">
                                                                                <input type="text" className="form-control form-control-lg" name="usuario" ref="usuario" placeholder="Usuario" required onChange={this.handleFormChange} />
                                                                                <div className="form-control-position"><i className="la la-user"></i></div>
                                                                            </fieldset>
                                                                            <fieldset className="form-group position-relative has-icon-left">
                                                                                <input type="password" className="form-control form-control-lg" name="clave" placeholder="Contraseña" required onChange={this.handleFormChange} />
                                                                                <div className="form-control-position"><i className="la la-key"></i></div>
                                                                            </fieldset>
                                                                            <div className="text-right mb-1">
                                                                                <button type="button" className="buttonAsLink primary" onClick={e => this.handleForgotPassword(e)}>¿Olvidó su contraseña?</button>
                                                                            </div>
                                                                            <button type="submit" className="btn btn-outline-primary btn-lg btn-block" disabled={!validationState.form.valid}>
                                                                                <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-lock'}></i> Ingresar
                                                                            </button>
                                                                        </form>
                                                                    )}
                                                                    {this.state.loginServices.google === 'true' && (
                                                                        <a href={this.state.googleLoginRedirect} className="d-block mt-2">
                                                                            <div className="card d-flex flex-row align-items-center justify-content-center p-1 border">
                                                                                <img src={process.env.PUBLIC_URL + "/images/google.svg"} style={{width: '30px'}} alt="" />
                                                                                <span className="ml-1">Sign in with Google</span>
                                                                            </div>
                                                                        </a>
                                                                    )}
                                                                    {this.state.loginServices.azure === 'true' && (
                                                                        <a href={this.state.azureLoginRedirect} className="d-block mt-1">
                                                                            <div className="card d-flex flex-row align-items-center justify-content-center p-1 border">
                                                                                <img src={process.env.PUBLIC_URL + "/images/microsoft.svg"} style={{width: '30px'}} alt="" />
                                                                                <span className="ml-1">Sign in with Microsoft</span>
                                                                            </div>
                                                                        </a>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    )}

                                                    <div className="row mt-2">
                                                        <div className="col-6">
                                                            <img src={process.env.PUBLIC_URL + "/images/company/logo-login-company.png"} alt="" className="img-fluid" />
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <img src={process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"} alt="" className="img-fluid" />
                                                        </div>
                                                    </div>
                                                    <div className="text-center mt-1">
                                                        <small className="text-muted">v{ process.env.REACT_APP_VERSION }</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(Login)
